import { RouterProvider } from 'react-router-dom';
import { PlatformAuthInitializer } from '@/components/platform/PlatformAuthInitializer';
import { Providers } from '@/providers';
import { platformRouter } from '@/routes/platform-router';

export function PlatformApp() {
  return (
    <Providers>
      <PlatformAuthInitializer>
        <RouterProvider router={platformRouter} />
      </PlatformAuthInitializer>
    </Providers>
  );
}
